export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/schoolYear/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        delete (data) {
            return http.json({
                url: '/schoolYear/delete',
                data
            });
        },
        saveInfo(data) {
            return http.json({
                url: `/schoolYear/schoolSave`,
                data
            });
        },
        queryAll(data) {
            return http.json({
                url: `/schoolYear/queryAll`,
                data
            });
        },
        getInfo(data) {
            return http.json({
                url: `/schoolYear/get?id=${data.id}`,
                data
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/schoolYear.js